import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api/axios';
import { toast } from 'react-toastify';

const Register = () => {
  const [form, setForm] = useState({ name: '', email: '', password: '', role: 'user' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/register', form);
      toast.success('Account created! Please login.');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoWrap}>
          <div style={styles.logoBox}><span style={styles.logoText}>MDM</span></div>
        </div>
        <h2 style={styles.title}>Create Account</h2>
        <p style={styles.sub}>Join the Master Data Management Portal</p>
        <form onSubmit={handleSubmit}>
          {[
            { label: 'Full Name', key: 'name', type: 'text', placeholder: 'John Doe' },
            { label: 'Email', key: 'email', type: 'email', placeholder: 'you@company.com' },
            { label: 'Password', key: 'password', type: 'password', placeholder: '••••••••' },
          ].map(f => (
            <div key={f.key}>
              <label style={styles.label}>{f.label}</label>
              <input style={styles.input} type={f.type} placeholder={f.placeholder} value={form[f.key]}
                onChange={e => setForm({ ...form, [f.key]: e.target.value })} required />
            </div>
          ))}
          <label style={styles.label}>Role</label>
          <select style={styles.input} value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}>
            <option value="user">User</option>
            <option value="checker">Checker</option>
            <option value="approver">Approver</option>
            <option value="it_support">IT Support</option>
            <option value="admin">Admin</option>
          </select>
          <button style={{ ...styles.btn, opacity: loading ? 0.7 : 1 }} type="submit" disabled={loading}>
            {loading ? 'Creating...' : 'Register'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14, color: '#555' }}>
          Already have an account? <Link to="/login" style={{ color: '#1A2C80', fontWeight: 600 }}>Login</Link>
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'linear-gradient(135deg, #0B1554 0%, #1A2C80 60%, #AC4168 100%)',
  },
  card: {
    background: '#fff', padding: '40px 44px', borderRadius: 12,
    boxShadow: '0 8px 40px rgba(11,21,84,0.25)', width: 380,
  },
  logoWrap: { display: 'flex', justifyContent: 'center', marginBottom: 16 },
  logoBox: {
    background: '#F7D506', borderRadius: 10, width: 52, height: 52,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  logoText: { color: '#0B1554', fontWeight: 900, fontSize: 16, letterSpacing: 1 },
  title: { textAlign: 'center', color: '#0B1554', marginBottom: 4, fontSize: 18, fontWeight: 700 },
  sub: { textAlign: 'center', color: '#888', marginBottom: 24, fontSize: 13 },
  label: { display: 'block', marginBottom: 5, fontSize: 13, fontWeight: 600, color: '#0B1554' },
  input: {
    width: '100%', padding: '10px 12px', marginBottom: 16,
    border: '1.5px solid #dde', borderRadius: 6, fontSize: 14,
    boxSizing: 'border-box', outline: 'none', color: '#0B1554',
  },
  btn: {
    width: '100%', padding: '12px', background: '#1A2C80', color: '#fff',
    border: 'none', borderRadius: 6, fontSize: 15, cursor: 'pointer', fontWeight: 700, marginTop: 4,
  },
};

export default Register;
